import { render, staticRenderFns } from "./Aiepi.vue?vue&type=template&id=44722a5a"
import script from "./Aiepi.vue?vue&type=script&lang=js"
export * from "./Aiepi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports